import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8943 18.8943C17.0658 20.7228 14.5859 21.75 12 21.75C9.41414 21.75 6.93419 20.7228 5.10571 18.8943C3.27723 17.0658 2.25 14.5859 2.25 12C2.25 10.7196 2.50219 9.45176 2.99217 8.26884C3.48216 7.08591 4.20034 6.01108 5.10571 5.10571C6.01108 4.20034 7.08591 3.48216 8.26884 2.99217C9.45176 2.50219 10.7196 2.25 12 2.25C13.2804 2.25 14.5482 2.50219 15.7312 2.99217C16.9141 3.48216 17.9889 4.20034 18.8943 5.10571C19.7997 6.01108 20.5178 7.08591 21.0078 8.26884C21.4978 9.45176 21.75 10.7196 21.75 12C21.75 14.5859 20.7228 17.0658 18.8943 18.8943ZM12.3659 15.5303C12.6588 15.8232 13.1337 15.8232 13.4266 15.5303C13.7195 15.2374 13.7195 14.7626 13.4266 14.4697L10.9569 12L13.4266 9.53033C13.7195 9.23744 13.7195 8.76256 13.4266 8.46967C13.1337 8.17678 12.6588 8.17678 12.3659 8.46967L9.36591 11.4697C9.07302 11.7626 9.07302 12.2374 9.36591 12.5303L12.3659 15.5303Z"
        fill={colorValue}
      />
    </svg>
  );
};
